import { useState } from "react";
import { Shield, Info } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import PageHeader from "@/components/PageHeader";
import BackupSettings from "@/components/BackupSettings";
import StandardSkusSettings from "@/components/StandardSkusSettings";
import ResponsabiliSettings from "@/components/ResponsabiliSettings";
import EmailSettings from "@/components/EmailSettings";
import ReminderSettings from "@/components/ReminderSettings";
import ConfirmCallSettings from "@/components/ConfirmCallSettings";
import PfsMapSettings from "@/components/PfsMapSettings";
import { ROLE_LABEL } from "@/lib/constants";

export default function Impostazioni() {
  const { user } = useAuth();

  const Row = ({ icon: Icon, title, desc, children }) => (
    <div className="flex items-start justify-between gap-4 border-b border-border/60 py-4 last:border-0">
      <div className="flex items-start gap-3">
        <span className="mt-0.5 flex h-9 w-9 items-center justify-center rounded-lg bg-secondary text-muted-foreground"><Icon size={16} /></span>
        <div>
          <p className="font-semibold text-navy">{title}</p>
          <p className="text-sm text-muted-foreground">{desc}</p>
        </div>
      </div>
      {children}
    </div>
  );

  return (
    <div className="space-y-6 animate-fade-up">
      <PageHeader overline="Flux · Amministrazione" title="Impostazioni" subtitle="Configurazione dell'applicazione" />

      <div className="rounded-xl border border-border bg-card p-6">
        <h3 className="mb-2 font-bold text-navy">Account</h3>
        <Row icon={Shield} title={user?.name} desc={user?.email}>
          <span className="rounded-full border border-violet-200 bg-violet-50 px-2.5 py-0.5 text-xs font-semibold text-violet-700">{ROLE_LABEL[user?.role]}</span>
        </Row>
        <Row icon={Info} title="Versione" desc="Flux Backoffice · v1.0.0" />
      </div>

      {user?.role === "admin" && <ResponsabiliSettings />}
      {user?.role === "admin" && <EmailSettings />}
      {user?.role === "admin" && <ReminderSettings />}
      {user?.role === "admin" && <ConfirmCallSettings />}
      {user?.role === "admin" && <PfsMapSettings />}
      {user?.role === "admin" && <StandardSkusSettings />}
      {user?.role === "admin" && <BackupSettings />}
    </div>
  );
}
